import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';

export interface Props {
  submit: () => void;
}

function NoParticipants({ submit }: Props) {
  return (
    <>
      <div className="md:max-h-[30vh] md:h-[30vh] sm:max-h-[20vh] sm:h-[20vh] text-sm overflow-y-auto">
        <div className="text-sm">
          <T kind="Start adding participants by searching them in the field above." />
        </div>
      </div>
      <div
        className={clsx(
          'pointer-events-none rounded-md bg-gray-500 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
        onClick={submit}
      >
        <T kind="Submit" />
      </div>
    </>
  );
}

export default observer(NoParticipants);
